import { useEffect, useState } from "react";
import { CheckCircle2, HeartHandshake, GraduationCap } from "lucide-react";
import { http } from "@/lib/api";
import { BuddyGrowth } from "@/components/buddy/teach/BuddyGrowth";
import { CareScene, CATEGORY_LABELS } from "@/components/buddy/teach/CareScene";
import { TeachLesson } from "@/components/buddy/teach/TeachLesson";

const MODES = [["care", "Help my buddy", HeartHandshake], ["lesson", "Teach what I learned", GraduationCap]];

export const TeachTab = () => {
  const [d, setD] = useState(null);
  const [mode, setMode] = useState("care");
  const [idx, setIdx] = useState(0);
  useEffect(() => { http.get("/buddy/teach").then((r) => { setD(r.data); const first = r.data.scenes.findIndex((s) => !r.data.progress.done.includes(s.id)); setIdx(Math.max(0, first)); }); }, []);
  if (!d) return <p className="text-stone-500" data-testid="teach-loading">Loading…</p>;

  const onResult = (r) => setD((x) => ({ ...x, progress: r.progress }));
  const scene = d.scenes[idx];
  return (
    <div className="space-y-8" data-testid="teach-tab">
      <BuddyGrowth p={d.progress} />
      <div className="flex flex-wrap gap-2">
        {MODES.map(([k, label, Icon]) => (
          <button key={k} onClick={() => setMode(k)} data-testid={`teach-mode-${k}`}
            className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm border transition-colors ${mode === k ? "bg-[#C87D53] text-white border-[#C87D53]" : "bg-white/70 border-[#E6DEC3] text-[#2C4A3E]"}`}>
            <Icon className="w-4 h-4" />{label}
          </button>
        ))}
      </div>
      {mode === "care" ? (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="scene-picker">
            {Object.entries(CATEGORY_LABELS).map(([cat, label]) => (
              <div key={cat} data-testid={`scene-group-${cat}`}>
                <p className="text-[11px] uppercase tracking-widest text-stone-500 mb-2">{label}</p>
                <div className="flex flex-wrap gap-1.5">
                  {d.scenes.map((s, i) => s.category === cat && (
                    <button key={s.id} onClick={() => setIdx(i)} data-testid={`scene-pick-${s.id}`}
                      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border ${i === idx ? "bg-[#2C4A3E] text-white border-[#2C4A3E]" : "bg-white/70 border-[#E6DEC3]"}`}>
                      {d.progress.done.includes(s.id) && <CheckCircle2 className={`w-3.5 h-3.5 ${i === idx ? "text-white" : "text-[#6B9080]"}`} />}{s.title}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <CareScene key={scene.id} scene={scene} onResult={onResult} onNext={() => setIdx((i) => (i + 1) % d.scenes.length)} />
        </>
      ) : (
        <TeachLesson topics={d.recent_topics} onResult={onResult} />
      )}
    </div>
  );
};
